module.exports = __webpack_public_path__ + "img/istop.bab00af7.png";